import _ from 'lodash'
const zxcvbn = require('zxcvbn');

//issue 254 - services
//const regexp = /.+@.+/
//const regexp = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g
const regexp =   /^[\w-.]+([+]([0-9A-Za-z]+)([ ])*)?@([\w-]+\.)+[\w-]{2,4}$/g
//issue 254 - services

export default {
  required (name) {
    return v => !!v || `${name} is required`
  },
  nowhitespace (name) {
    return v => (typeof v === 'string' && !(v.includes(' ') || v.includes("\t"))) || `${name} cannot contain white spaces`
  },
  password: v => (v && v.length >= 8) || 'The password must have at least 8 characters',
  confirm_password: (v, password) => {
    return (v && v === password) || 'The password does not match'
  },
  different_password: (v, old_password) => {
    return (v && v !== old_password) || 'The new password must be different from the old one'
  },
  check_simple_password: (v) => {
    if (v === null || v === undefined) {
      v = '';
  }
    const ret = zxcvbn(v);
    let result;

    if (ret.score >= 3) {
        result = ret.score;
    } else if (ret.feedback && ret.feedback.warning) {
        result = ret.feedback.warning;
    } else if (ret.feedback && ret.feedback.suggestions && ret.feedback.suggestions[0]) {
        result = true;
    } else {
        result = ret.feedback.suggestions[0];
    }

    //issue 344
    if (result)
    {
      result = true
    }
    //issue 344

    return result;
  },
  password_strong: (value) => {
    var regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!£@#$%^&*()_\-+=[\]{};:'",.<>?/\\|`~])[A-Za-z\d!£@#$%^&*()_\-+=[\]{};:'",.<>?/\\|`~]{8,}$/;
    //NOTE:la regularExpression (utilizzata negli altri software) è stata commentata perchè in questo applicativo 
    // è presente "eslint": "^6.7.2" che genera un errore relativamente agli escape,l'espressione di sopra 
    // è stata modificata per evitare l'errore
    //var regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!£@#$%^&*()_\-+=\[\]{};:'",.<>?\/\\|`~])[A-Za-z\d!£@#$%^&*()_\-+=\[\]{};:'",.<>?\/\\|`~]{8,}$/;


    if (!regularExpression.test(value)) {
            return "The password must have minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character";
    }
    return true;
},
  email () {
    return v => {regexp.lastIndex = 0; return !v || regexp.test(v) || 'E-mail must be valid' } //issue 254 - services
  },
  number (name) {
    return v => isFinite(v) || `${name} has to be a number`
  },
  natural (name) { 
    return v => isFinite(v) && v > 0 || `${name} has to be a number`
  },
  serials () {
    return serials => {
      if (!serials) return true
      if (!/^[0-9,\- ]*$/.test(serials)) {
        return 'Invalid serials (only 0-9 , or - allowed)'
      }

      const normalized = _(serials)
        .split(/,|\n| /)
        .invokeMap('trim')      // trim
        .filter(c => c)         // tolgo i vuoti
        .value()

      for (let chunk of normalized) {
        if (!chunk.includes('-')) continue
        let [min, max] = chunk.split('-')
        min = Number(min)
        max = Number(max)
        if (min>max) return 'Range should be min-max'
        if (max-min>10000) return 'Range should not contain more than 10k serials'
      }
      return true
    }
  },
  username: [
    v => !!v || 'Username is required',
  ],
  account: {
    email: [
      v => !!v || 'Email is required',
      v => {regexp.lastIndex = 0; return regexp.test(v) || 'E-mail must be valid' } //issue 254 - services
    ],
    password: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 8) || 'The password must have at least 8 characters'
    ],
    name: [
      v => !!v || 'Name is required'
    ],
    surname: [
      v => !!v || 'Surname is required'
    ],
    role: [
      v => !!v || 'Role is required'
    ],
    status: [
      v => !!v || 'Status is required'
    ]
  }
}
